import { render, staticRenderFns } from "./PrismEditor.vue?vue&type=template&id=c0855c56&scoped=true&"
import script from "./PrismEditor.vue?vue&type=script&lang=js&"
export * from "./PrismEditor.vue?vue&type=script&lang=js&"
import style0 from "./PrismEditor.vue?vue&type=style&index=0&id=c0855c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0855c56",
  null
  
)

export default component.exports